<template>
  <div id="cv">
    <a href="./assets/Lewis A Mckeown CV.pdf" target="_blank" class="download-link">CV Download</a>
    <!-- <cv-switcher  -->
    <button
        v-for="tab in tabs"
        v-bind:key="tab.name"
        v-bind:class="['tab-button', { active: currentTab.name === tab.name }]"
        v-on:click="currentTab = tab"
      >
        {{tab.name}}
      </button>
      <keep-alive>
        <component v-bind:is="currentTab.component"></component>
      </keep-alive>
  </div>
</template>

<script>
import CvChrono from '../components/CvChrono.vue'
import CvHighlights from '../components/CvHighlights.vue'

let tabs = [
        {
          name: '🙌 Highlights',
          component: CvHighlights
        },
        {
          name: '🕐 The Whole Story',
          component: CvChrono
        },
      ];

export default {
  name: 'CV',
  data: function() {
      return {
        tabs: tabs,
        currentTab: tabs[0]
      };
  },
}
</script>
<style>
  .download-link {
    display: block;
    padding: 0.5em;
    font-size: 22px;
    padding-bottom: 1em;
  }
  .download-link:hover {
    border-bottom: none;
  }
  .tab-button {
    padding: 0.5em;
    width: 20em;
    font-size: 16px;
    color: #565656;
    border: none;
    background: white;
    border-bottom: 1px solid #565656;
    cursor: pointer;
    margin-bottom: -1px;
    margin-right: -1px;
  }
  .tab-button:hover {
    color: black;
    border-bottom: 2px solid black;
    font-weight: bold;
  }
  .tab-button.active {
    color: black;
    font-weight: bold;
    border-bottom: 2px solid black;
  }

  @media screen and (max-width: 500px) {
    .tab-button {
      float: none;
      /* display: block;
      align-self: center; */
      width: 100%;
    }
  }
</style>
